/** 관리 폼의 공용 클래스. 폼이 여러 화면에 흩어져 있어 입력 높이가 갈라지기 쉽다. */
export const FIELD =
  'w-full rounded-lg border border-neutral-200 bg-white px-3 py-2 text-[14px] text-neutral-900 outline-none focus:border-brand-500 dark:border-white/12 dark:bg-dark-card dark:text-neutral-100';
export const LABEL =
  'mb-1.5 block text-[12.5px] font-bold text-neutral-600 dark:text-neutral-300';
export const BTN =
  'inline-flex h-9 items-center rounded-lg px-3.5 text-[13px] font-bold transition-colors';
export const BTN_PRIMARY = `${BTN} bg-brand-500 text-white hover:bg-brand-600 disabled:cursor-not-allowed disabled:opacity-50`;
export const BTN_GHOST = `${BTN} border border-neutral-200 text-neutral-700 hover:bg-neutral-50 dark:border-white/12 dark:text-neutral-200 dark:hover:bg-white/5`;
export const BTN_DANGER = `${BTN} border border-danger/40 text-danger hover:bg-danger/5`;
